export const json = {
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "Domanda1",
                    "choices": [
                        "Item 1",
                        "Item 2",
                        "Item 3"
                    ]
                }
            ]
        }
    ],
    "showProgressBar": "bottom",
    "startSurveyText": "Start Quiz",
    "maxTimeToFinish": 25,
    "maxTimeToFinishPage": 10,
    "showTimerPanel": "top",
    "peso_orario": "1.00"
};
